import { message } from "antd"
import { IPlacementDataForUpdate } from "../store/types/placements"
import { IPlacementDataTable } from "../types/placement"
import { placementsEnum } from "../types/types"

interface IUseAudienceProps {
  setPlacementsDataForUpdate: React.Dispatch<React.SetStateAction<IPlacementDataForUpdate[]>>
  selectedCampaignIds: number[]
  selectedAudience: string | null
}

const useAudience = ({
  setPlacementsDataForUpdate,
  selectedCampaignIds,
  selectedAudience,
}: IUseAudienceProps) => {
  function applyAudiencesToSelectedCampaigns(): boolean {
    if (!selectedAudience) {
      message.error("Please select an audience")
      return false
    }

    setPlacementsDataForUpdate((prev) => {
      return prev.map((placement) => {
        if (selectedCampaignIds.includes(placement.campaignId)) {
          return {
            ...placement,
            placements: updateAudienceIdPlacements(placement, selectedAudience),
          }
        }

        return placement
      })
    })
    return true
  }

  function updateAudienceIdPlacements(
    placement: IPlacementDataForUpdate,
    audienceId: string
  ): IPlacementDataTable[] {
    return placement.placements.map((placement) => {
      if (placement.placement === placementsEnum.AUDIENCE) {
        return {
          ...placement,
          audienceId,
        }
      }

      return placement
    })
  }

  return {
    applyAudiencesToSelectedCampaigns,
  }
}

export default useAudience
